export default __webpack_public_path__ + "static/media/banner_bg_3.0259bf89.jpg";